// App.js

import React from "react";
import styled from "styled-components";
import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import Frame1010108758 from "./components/Webapp";
import ScrollToTop from "./components/ScrollToTop";
import LogsDashboard from "./components/Logs";

function App() {
  // Don't render React Router for admin paths
  if (window.location.pathname.startsWith("/admin/")) {
    return <div>Loading admin interface...</div>;
  }
  return (
    <Router>
      <ScrollToTop /> {/* Scroll to top on route change */}
      <Switch>
        <Route path="/user-homepage" component={Frame1010108758} />
        <Route path="/logs" component={LogsDashboard} />
        <Redirect from="/" to="/user-homepage" />
      </Switch>
    </Router>
  );
}

export default function WrappedApp() {
  return <App />;
}
